import * as types from './mutation-types'
import { getAgences } from '../../../api/agence'

const getInitialState = () => {
  return {
    agencesOptions: []
  }
}

const state = { ...getInitialState() }

const mutations = {
  [types.SET_AGENCES](state, agencesOptions) {
    state.agencesOptions = agencesOptions
  }
}

const actions = {
  async getAgences({ commit }) {
    const agencesOptions = await getAgences()
    commit(types.SET_AGENCES, agencesOptions)
  }
}

const getters = {
  agencesOptions: state => state.agencesOptions
}

export default { state, mutations, actions, getters }
